import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import '../timeSheet.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faFilter, faFilterCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { faCircleCheck, faCircleDown, faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { Box, TextField } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

function TimesheetAdmin() {
    const navigate = useNavigate();
    const [selectedDate, setSelectedDate] = useState(null);
    const [isGridVisible, setGridVisible] = useState(false);
    const [weekRange, setWeekRange] = useState("");

    const toggleGrid = () => {
        setGridVisible((prev) => !prev);
    };
    const handleDateChange = (date) => {
        setSelectedDate(date);

        if (date) {
        //   const day = date.day(); // 0 (Sunday) to 6 (Saturday)
        const sunday = date.startOf("week"); // Sunday
        const saturday = sunday.add(6, "day"); // Saturday

        const formattedRange = `${sunday.format("DD/MM/YYYY")} to ${saturday.format("DD/MM/YYYY")}`;
        setWeekRange(formattedRange);
        } else {
        setWeekRange("");
        }
    };

  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                    <h3>Timesheet Management</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Timesheet Management</span>
                </Grid>
                <Grid size={{ xs: 12 }} container justifyContent="flex-end" alignItems="center" className="my-4">
                    <Grid size={{xs:12}} container justifyContent="flex-end">
                        <button className='download_csvbtndatatable'>Download CSV<FontAwesomeIcon className='ps-2' icon={faCircleDown} /></button>
                    </Grid>
                    <Grid size={{ sm:6,xs: 12 }} container alignItems="center" className="gap-3 regiter_inputs i94validateinput">
                        <Grid container className="d-none">
                            <div className='profile_show d-none'>
                                <img src={require("../../../assets/defaultprofile.svg").default} alt=''/>
                                <div className='profile_sheet_content'>
                                    <span className='my-0'>Matthew Johnson</span>
                                    <small>EMPLID002345</small>
                                </div>
                            </div>
                        </Grid>
                        {isGridVisible && (
                            <Box sx={{ mb: 2 }} className="my-4">
                                <Box sx={{ display: 'flex', alignItems: 'end', mb: 1 }} className="gap-3 select_sheetfilter">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        className="date_pickermux date_selectsheet"
                                        value={selectedDate}
                                        onChange={handleDateChange}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </LocalizationProvider>
                                        <Grid container flexDirection="column">
                                            <label>Employee</label>
                                            <select
                                                sx={{ mr: 1, minWidth: 80 }}
                                            >
                                            <option value="All">All</option>
                                            </select>
                                        </Grid>
                                        <Grid container flexDirection="column">
                                            <label>Status</label>
                                            <select
                                                sx={{ mr: 1, minWidth: 80 }}
                                            >
                                            <option value="All">All</option>
                                            </select>
                                        </Grid>
                                        <Grid container flexDirection="column">
                                            <label>Project</label>
                                            <select
                                                sx={{ mr: 1, minWidth: 80 }}
                                            >
                                            <option value="All">All</option>
                                            </select>
                                        </Grid>
                                    </Box>
                            </Box>)}
                            <Grid size={{xs:12}} container justifyContent="space-between">
                                <button className='download_csvbtndatatable' onClick={toggleGrid}>
                                    {isGridVisible ?<> Hide Filter <FontAwesomeIcon icon={faFilterCircleXmark} /> </> :<> Show Filter <FontAwesomeIcon icon={faFilter} /> </>}
                                </button>
                            </Grid>
                        {weekRange && <input style={{width:"max-content"}} value={weekRange} disabled />}
                    </Grid>
                    <Grid size={{ sm:6,xs: 12 }} container justifyContent="flex-end" className="gap-3">
                        <button className='registersendbtn1 my-0 px-4' style={{width:"max-content"}} onClick={()=>navigate("/timesheet/project-assign")}>Project / Assignment</button>
                    </Grid>
                </Grid>
                <Grid size={{xs:12}} container className="mt-4 timesheet_table">
                    <table className="table table-bordered" style={{minWidth:"1700px"}}>
                        <thead>
                            <tr>
                                <th><input type='checkbox'/></th>
                                <th>EMPLOYEE NAME</th>
                                <th className='text-start'>PROJECTS</th>
                                <th className='blue_bgcell_sheet'><span className='d-flex flex-column'>SUN<small>12/01</small></span></th>
                                <th><span className='d-flex flex-column'>MON<small>12/02</small></span></th>
                                <th><span className='d-flex flex-column'>TUE<small>12/03</small></span></th>
                                <th><span className='d-flex flex-column'>WED<small>12/04</small></span></th>
                                <th><span className='d-flex flex-column'>THU<small>12/05</small></span></th>
                                <th><span className='d-flex flex-column'>FRI<small>12/06</small></span></th>
                                <th className='blue_bgcell_sheet'><span className='d-flex flex-column'>SAT<small>12/07</small></span></th>
                                <th>STATUS</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='text-center'><input type='checkbox'/></td>
                                <td className='text-start'>
                                    <span className='sheet_pronamepink'>HR Training</span>
                                </td>
                                <td className='text-start'>
                                    <span className='sheet_pronamepink'>HR Training</span>
                                </td>
                                <td className='blue_bgcell_sheet'><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td className='blue_bgcell_sheet'><input /></td>
                                <td>
                                    <span className='rejected_timesheet'><FontAwesomeIcon icon={faCircleXmark} /> Rejected</span>
                                </td>
                            </tr>
                            <tr>
                                <td className='text-center'><input type='checkbox'/></td>
                                <td className='text-start'>
                                    <span className='sheet_pronamepink'>HR Training</span>
                                </td>
                                <td className='text-start'>
                                    <span className='sheet_pronamepink'>HR Training</span>
                                </td>
                                <td className='blue_bgcell_sheet'><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td className='blue_bgcell_sheet'><input /></td>
                                <td>
                                    <span className='submitted_timesheet'><FontAwesomeIcon icon={faCircleCheck} /> Submitted</span>
                                </td>
                            </tr>
                            <tr>
                                <td className='text-center'><input type='checkbox'/></td>
                                <td className='text-start'>
                                    <span className='sheet_pronamepink'>HR Training</span>
                                </td>
                                <td className='text-start'>
                                    <span className='sheet_pronamepink'>HR Training</span>
                                </td>
                                <td className='blue_bgcell_sheet'><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td className='blue_bgcell_sheet'><input /></td>
                                <td>
                                    <span className='approved_timesheet'><FontAwesomeIcon icon={faCircleCheck} /> Approved</span>
                                </td>
                            </tr>

                            <tr>
                                <td className='text-center'></td>
                                <td className='text-start'>
                                    Total
                                </td>
                                <td></td>
                                <td>0.00</td>
                                <td>15.00</td>
                                <td>15.00</td>
                                <td>14.00</td>
                                <td>17.00</td>
                                <td>16.00</td>
                                <td>0.00</td>
                                <td>77.00</td>
                            </tr>
                        </tbody>
                    </table>
                </Grid>
            </Grid>
        </div>
    </div>
  );
}

export default TimesheetAdmin;